exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-profiel-overzicht .row--form-item div{text-align:left}.page-profiel-overzicht .row--form-item div:first-child{text-align:right;font-family:FranklinGothicDemi}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46048520","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-profiel-overzicht.vue
// module id = 59
// module chunks = 0